















import newEngageMessageSelectTemplateStep from "./newEngageMessageSelectTemplateStep.vue";
import newEngageMessageCreateSelectContactsStep from "./newEngageMessageCreateSelectContactsStep.vue";
import newEngageMessageSelectChannel from "./newEngageMessageSelectChannel.vue";
import newEngageMessageOverview from "./newEngageMessageOverview.vue";
import newEngageMessageCreateContactListStep from "./newEngageMessageCreateContactListStep.vue";
import newEngageMessageNameMessage from "./newEngageMessageNameMessage.vue";
import newEngageMessageSchedule from "@/views/modules/engage/create/steps/newEngageMessageSchedule.vue";

export default {
    components: {
        newEngageMessageSelectTemplateStep,
        newEngageMessageCreateSelectContactsStep,
        newEngageMessageSelectChannel,
        newEngageMessageOverview,
        newEngageMessageCreateContactListStep,
        newEngageMessageNameMessage,
        newEngageMessageSchedule,
    },
    props: {
        currentStep: {
            type: Object,
            required: true,
        },
    },
    emits: ["templateSelected", "editFinished", "channelSelected"],
    methods: {
        // @ts-ignore
        onEditFinished(data) {
            // @ts-ignore
            this.$emit("editFinished", data);
        },
        // @ts-ignore
        onTemplateSelected(data) {
            // @ts-ignore
            this.$emit("templateSelected", data);
        },
        // @ts-ignore
        onChannelSelected(data) {
            // @ts-ignore
            this.$emit("channelSelected", data);
        },
        // @ts-ignore
        onNameSelected(data) {
            // @ts-ignore
            this.$emit("nameSelected", data);
        },
    },
};
